import React, { Component } from 'react';
import './RankingListItem.css';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

class RankingListItem extends Component {

    render() {
        let classes = classnames({
            'ranking-list-item': true,
            'row': true,
            'user-mark': this.props.user.uid ===  this.props.rankUser,
        });
        return (
            <div className={classes}>
                <div className="col-2 text-right">{this.props.rank.position}.</div>
                <div className="col-8 text-right">{this.props.rank.displayName}<br />{this.props.rank.points} <FormattedMessage id={ 'ranking.ranking_list_item.points' } defaultMessage={ 'Punkte' } /></div>
                <div className="col-2"><div className="image rounded-circle"><img src={this.props.rank.photoURL} alt=""/></div></div>
            </div>
        );
    }
}

export default RankingListItem;



// WEBPACK FOOTER //
// ./src/Ranking/RankingListItem.js